// eslint-disable-next-line no-restricted-imports
import { TradingSessionEnum } from '@eih-netbroker/api-order';

export const TradingSession = TradingSessionEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TradingSession = (typeof TradingSession)[keyof typeof TradingSession];
